import { Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-tooltip-icon',
  imports: [MatIcon, NgClass],
  templateUrl: './tooltip-icon.component.html',
  styleUrl: './tooltip-icon.component.scss'
})
/**
 * Begründung: Hierbei handelt es sich um eine allgemeine Komponente, welche ein TooltipIcon breitstellt und über einen
 * Hover effect einen Tooltip gibt, basierend auf dem Design der Anwendung.
 */
export class TooltipIconComponent {
  infoText = input.required<string>();
  infoTitle = input.required<string>();
  alignTooltip = input<string>();
}
